function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import * as _ from 'lodash';
import * as d3 from 'd3';
var POINT_RADIUS = 3.5;
var CAPTION_1_FONT_SIZE = 12;
var SUB_CAPTION_FONT_SIZE = 10;
var GS_DARKEST = '#111111';
var GS_DARK = '#414141';
var GS_MIDDLE = '#A0A0A0';
var GS_MED_LIGHT = '#B7B7B7';
var DATA_GRAY = '#546E7A';
var TAP_PADDING = 2;
var DRAG_PIXELS_TO_PAGINATE = 12;
var FONT_FAMILY = 'GT America';

String.prototype.hashCode = function () {
  var hash = 0;

  for (var i = 0; i < this.length; i++) {
    var character = this.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash = hash & hash;
  }

  return hash;
};

var DatePrecision = /*#__PURE__*/function () {
  function DatePrecision(precision) {
    _classCallCheck(this, DatePrecision);

    this.precision = precision;
  }

  _createClass(DatePrecision, [{
    key: "isYear",
    value: function isYear() {
      return this.precision === 'P1Y';
    }
  }, {
    key: "isMonth",
    value: function isMonth() {
      return this.precision === 'P1M';
    }
  }, {
    key: "isDay",
    value: function isDay() {
      return this.precision === 'P1D' || this.precision === 'P1DT';
    }
  }]);

  return DatePrecision;
}();

var GraphConfig = function GraphConfig(margin, precision, data, width, height, niceTicks, timeExtents, yAxisWidth, yTicks, timeFormat) {
  _classCallCheck(this, GraphConfig);

  this.getX = function () {
    return d3.scaleUtc().domain(this.timeExtents).range([this.margin.left + 24, this.width - this.margin.right - 24]);
  };

  this.getY = function () {
    var values = _.map(this.data, function (d) {
      return +d.v;
    });

    var max = d3.max(values);
    var min = d3.min(values);
    return d3.scaleLinear().domain([min, max]).nice(this.niceTicks).rangeRound([this.height - this.margin.bottom - 12, this.margin.top]);
  };

  this.margin = margin;
  this.precision = precision;
  this.data = data;
  this.width = width;
  this.height = height;
  this.niceTicks = niceTicks;
  this.timeExtents = timeExtents;
  this.yAxisWidth = yAxisWidth;
  this.yTicks = yTicks;
  this.timeFormat = timeFormat;
};

var TextObserver = /*#__PURE__*/function () {
  function TextObserver() {
    _classCallCheck(this, TextObserver);

    var canvas = document.createElement('canvas');
    this.context = canvas.getContext('2d');
  }

  _createClass(TextObserver, [{
    key: "getWidth",
    value: function getWidth(text, fontSize, fontFace) {
      this.context.font = fontSize + 'px ' + fontFace;
      return this.context.measureText(text).width;
    }
  }]);

  return TextObserver;
}();

var textObserver = new TextObserver();

function determineTrackableName(records, locale) {
  var trackableNames = _.map(records, 'name');

  var keys = _.uniq(trackableNames);

  if (keys.length > 1) {
    throw new Error('Mixed trackables – cannot draw graph');
  }

  return keys[0];
}

var TrackableObservationGraph = /*#__PURE__*/function () {
  function TrackableObservationGraph(id, width, height, records, locale) {
    _classCallCheck(this, TrackableObservationGraph);

    this.id = id;
    this.width = width;
    this.height = height;
    this.records = _.uniqBy(records, 'date.date');
    this.locale = locale;
    this.p1dFormatter = d3.timeFormat('%b %d, %Y');
    this.p1mFormatter = d3.timeFormat('%b %Y');
    this.p1yFormatter = d3.timeFormat('%Y');
  }

  _createClass(TrackableObservationGraph, [{
    key: "setDateFormatters",
    value: function setDateFormatters(p1dFormatter, p1mFormatter, p1yFormatter) {
      this.p1dFormatter = p1dFormatter;
      this.p1mFormatter = p1mFormatter;
      this.p1yFormatter = p1yFormatter;
    }
  }, {
    key: "hash",
    value: function hash() {
      var id = this.id,
          hash = _objectWithoutProperties(this, ["id"]);

      var hashCode = JSON.stringify(hash).hashCode();
      return hashCode;
    }
  }, {
    key: "createSVG",
    value: function createSVG() {
      var id = this.id;
      var width = this.width;
      var locale = this.locale;
      var p1dFormatter = this.p1dFormatter;
      var p1mFormatter = this.p1mFormatter;
      var p1yFormatter = this.p1yFormatter;
      var unit = determineTrackableName(this.records, locale);

      var valueFormatter = function valueFormatter() {
        return function () {
          return '';
        };
      };
      /**
       * Transforms observation data array into manageable object array
       * returns [
       *  { date: '2020-03-04', precision: 'P1D'},
       *  { date: '2020-03-05', precision: 'P1D'},
       * ]
       */


      function prepareData(records) {
        var data = _.reduce(records, function (acc, record) {
          var date = _.get(record, 'date.date');

          var precision = _.get(record, 'date.precision');

          if (_.isUndefined(date)) {
            throw new Error('Cannot display, dataset contains an observation without date');
          }

          if (date && precision) {
            acc.push({
              date: date,
              precision: precision
            });
          }

          return acc;
        }, []);

        return _.sortBy(data, ['date']);
      }

      function gatherDataset(records) {
        function filterData(input, isLastPage) {
          var precision = _.reduce(input, function (acc, d) {
            var dp = new DatePrecision(d.precision);

            if (acc.isYear() || dp.isYear()) {
              return new DatePrecision('P1Y');
            }

            if (acc.isMonth() || dp.isMonth()) {
              return new DatePrecision('P1M');
            }

            return acc;
          }, new DatePrecision('P1D'));

          var data = _.map(input, function (da) {
            var v = 1;
            var p = da.precision;
            var d = da.date;
            var t = d;
            var comp = t.split('-');

            if (precision.isYear()) {
              t = "".concat(comp[0], "-01-01");
            } else if (precision.isMonth()) {
              t = "".concat(comp[0], "-").concat(comp[1], "-01");
            }

            return {
              v: v,
              d: d,
              t: d3.timeParse('%Y-%m-%d')(t),
              p: p
            };
          });

          function timeFormat(pin) {
            return function (d) {
              var p = pin || precision;

              if (p.isYear()) {
                return p1yFormatter(d);
              } else if (p.isMonth()) {
                return p1mFormatter(d);
              } else if (p.isDay()) {
                return p1dFormatter(d);
              }
            };
          }

          var rightNavPad = isLastPage ? 0 : 26;
          var margin = {
            top: 32,
            right: 28 + rightNavPad,
            bottom: 30,
            left: 50
          };
          var timeExtents = d3.extent(data, function (d) {
            return d.t;
          });
          var max = 1;
          var min = 1;
          var niceTicks = 1;
          var yTicks = d3.scaleLinear().domain([min, max]).nice(niceTicks).ticks(niceTicks);
          var xAxisHeight = 16 + 8;
          var yLabelHeight = 16 + 12;
          var yTickHeight = 16 + 8;
          var height = xAxisHeight + yLabelHeight + yTickHeight * yTicks.length;
          var y = d3.scaleLinear().domain([min, max]).nice(niceTicks).rangeRound([height - margin.bottom - 12, margin.top]);
          var yAxisWidth = 15;
          return new GraphConfig(margin, precision, data, width, height, niceTicks, timeExtents, yAxisWidth, yTicks, timeFormat);
        }

        function hasDateCollisions(x, records) {
          var times = _.map(records, function (r) {
            return +r.t;
          });

          var sorted = _.sortBy(times);

          var unique = _.uniq(sorted);

          for (var i = 0; i < unique.length - 1; i++) {
            var px1 = x(unique[i]) + POINT_RADIUS + 1;
            var px2 = x(unique[i + 1]) - POINT_RADIUS - 1;

            if (px1 > px2) {
              return true;
            }
          }

          return false;
        } // iterate all the data points backwards to produce the page(s)
        // with the most recent data data-full


        var pages = [];
        var pagedRecords = [];
        var graphConfig;
        var isLastPage = true;

        while (records.length > 0) {
          var record = records.pop(); // take last date from array

          pagedRecords.unshift(record); // insert that record to the paged set

          var newGraphConfig = filterData(pagedRecords, isLastPage);
          var collisions = hasDateCollisions(newGraphConfig.getX(), newGraphConfig.data); // determine collisions

          if (collisions) {
            // if dates collided, put the record back
            records.push(record);
            pages.unshift(graphConfig); // insert the last successful page (graphConfig)

            pagedRecords = [];
            isLastPage = false;
          }

          if (records.length === 0) {
            // drained the records, add page -- only possible if no collisions
            pages.unshift(newGraphConfig);
            break;
          }

          graphConfig = newGraphConfig;
        }

        var maxHeight = _.max(_.map(pages, function (page) {
          return page.height;
        }));

        var maxYAxisWidth = 20;
        pages.forEach(function (page, index) {
          page.height = maxHeight;
          page.yAxisWidth = index === 0 ? 0 : maxYAxisWidth;
          page.margin.left = page.yAxisWidth + 20;
        });
        return pages;
      }

      function renderGraphData(svg, pages, pageIndexToRender) {
        var graphConfig = pages[pageIndexToRender];
        var margin = graphConfig.margin,
            data = graphConfig.data,
            height = graphConfig.height,
            yTicks = graphConfig.yTicks,
            timeFormat = graphConfig.timeFormat;
        var x = graphConfig.getX();
        var y = graphConfig.getY();

        function getXTickList() {
          var _d3$timeDay;

          // # of days from start date to end date (does not include end date)
          var numDays = (_d3$timeDay = d3.timeDay).count.apply(_d3$timeDay, _toConsumableArray(x.domain()));

          var xTicks = [];
          var maxXTicks = isWide ? 4 : 2;

          if (numDays < maxXTicks) {
            maxXTicks = numDays > 0 ? numDays : 1;
          }

          var tickGap = plotWidth / maxXTicks;

          for (var i = 0; i <= maxXTicks; i++) {
            var pos = tickGap * i + margin.left + 24;
            xTicks.push(x.invert(pos));
          } // two date points, two ticks


          if (data.length === 2) {
            xTicks = d3.extent(xTicks);
          }

          return xTicks;
        }

        function getXTickGroups() {
          return _.groupBy(data, 't');
        }

        function clearTooltips() {
          d3.selectAll("#".concat(id, " .tooltip")).remove();
          d3.select("#".concat(id, " .unit")).classed('transparent', false);
        }

        ;

        function xAxis(g) {
          g.attr("transform", "translate(-0.5,".concat(height - margin.bottom, ")"));
          g.select('.custom-domain').remove();
          g.select("#x-axis-clip").remove();
          g.append("clipPath").attr("id", "x-axis-clip").append("rect").attr("x", margin.left - 12).attr("y", -5).attr("width", width - margin.right - 8).attr("height", 32);
          return g.select("#x-axis-content").attr("clip-path", pageIndexToRender > 0 ? "url(#x-axis-clip)" : "").call(function (g) {
            return g.append("line").attr("class", "custom-domain").attr("x1", margin.left - 8).attr("x2", width - margin.right).attr("stroke-width", 1).attr("stroke", GS_MED_LIGHT);
          }).transition(d3.transition().duration(450).ease(d3.easeBackOut.overshoot(0.6))).call(d3.axisBottom(x).tickFormat(timeFormat()).tickValues(getXTickList())).on("start", function () {
            return g.select(".domain").remove();
          }).call(function (g) {
            return g.selectAll(".tick line").attr("y1", -5).attr("stroke", GS_MIDDLE);
          }).call(function (g) {
            return g.selectAll(".tick text").attr("y", 12).attr("style", "font-size: ".concat(CAPTION_1_FONT_SIZE, "px; fill: ").concat(GS_DARK));
          });
        }

        function yAxis(g) {
          g.attr("transform", "translate(".concat(margin.left, ",0)"));
          g.select("#nav-container").remove();
          var container = g.append("g").attr("transform", "translate(-".concat(margin.left, ", ").concat(height - 26, ")")).attr("id", "nav-container");
          g.select("#y-axis-clip").remove();
          g.append("clipPath").attr("id", "y-axis-clip").append("rect").attr("x", "-".concat(margin.left)).attr("y", 20).attr("width", margin.left).attr("height", height - margin.bottom - 14);
          g.select("#y-axis-content").attr("clip-path", "url(#y-axis-clip)").transition(d3.transition().duration(100).ease(d3.easeLinear)).call(d3.axisLeft(y).tickPadding(8).tickFormat(valueFormatter()).tickValues(yTicks)).on("start", function () {
            return g.select(".domain").remove();
          }).call(function (g) {
            return g.selectAll(".tick line").attr("stroke-opacity", 0);
          }).call(function (g) {
            return g.selectAll(".tick text").attr("text-anchor", "end").attr("style", "font-size: ".concat(CAPTION_1_FONT_SIZE, "px; fill: ").concat(GS_DARK));
          }).call(function (g) {
            return g.select(".domain").remove();
          });
          container.append("g").attr("style", "fill: ".concat(GS_MIDDLE)).call(function (gl) {
            if (pageIndexToRender > 0) {
              gl.append("g").attr("transform", "translate(".concat(margin.left - 32, ", 0)")).append("path").attr("d", "M15.3,16.5c0.4,0,0.7-0.3,0.7-0.7V8.2c0-0.1,0-0.2-0.1-0.3c-0.2-0.3-0.6-0.5-0.9-0.3l-6.7,3.8c-0.1,0.1-0.2,0.1-0.3,0.3C7.9,12,8,12.4,8.3,12.6l6.7,3.8C15.1,16.5,15.2,16.5,15.3,16.5z");
              gl.append("rect").attr("x", 4).attr("y", 2).attr("height", 20).attr("width", margin.left - 12).attr("style", "opacity: 0").on("click", pageBack);
            }
          });
          container.append("g").attr("style", "fill: ".concat(GS_MIDDLE)).attr("transform", "translate(".concat(width - 44, ", 0)")).call(function (gr) {
            if (pageIndexToRender < pages.length - 1) {
              gr.append("path").attr("d", "M9,16.4l6.7-3.8c0.3-0.2,0.4-0.6,0.3-0.9c-0.1-0.1-0.1-0.2-0.3-0.3L9,7.6c-0.3-0.2-0.8,0-0.9,0.3C8,8,8,8.1,8,8.2v7.7c0,0.4,0.3,0.7,0.7,0.7C8.8,16.5,8.9,16.5,9,16.4z");
              gr.append("rect").attr("x", 2).attr("y", 2).attr("height", 20).attr("width", margin.right).attr("style", "opacity: 0").on("click", pageForward);
            }
          });
          return container;
        }

        function tapBackground(rect) {
          return rect.attr("x", 0).attr("y", 0).attr("width", width).attr("height", height).attr("style", "fill: transparent").on("click", clearTooltips);
        }

        function truncateText() {
          var self = d3.select(this);
          var text = self.text();
          var textLength = textObserver.getWidth(text, CAPTION_1_FONT_SIZE, FONT_FAMILY);

          while (textLength > width && text.length > 0) {
            text = text.slice(0, -1);
            var truncatedText = "".concat(text, "...");
            self.text(truncatedText);
            textLength = textObserver.getWidth(truncatedText, CAPTION_1_FONT_SIZE, FONT_FAMILY);
          }
        }

        function unitLabel(text) {
          return text.attr('class', 'unit').attr("y", 0).attr("x", 0).attr("dy", "1em").attr("style", "font-size: ".concat(CAPTION_1_FONT_SIZE, "px; fill: ").concat(GS_DARK)).text(unit).each(truncateText);
        }

        function points(g) {
          return g.selectAll("g").data(data).join("g").attr("fill", "#546E7A").call(function (g) {
            return g.append('circle').attr("style", "opacity: 0").attr("cx", function (d) {
              return x(d.t);
            }).attr("cy", function (d) {
              return y(d.v);
            }).attr("r", POINT_RADIUS).transition().attr("style", "opacity: 1");
          });
        }

        function bars(g) {
          var collisions = [];

          function addCollision(t, py1, py2) {
            collisions.push({
              t: t,
              py1: py1,
              py2: py2
            });
          }

          for (var _i = 0, _Object$values = Object.values(tickBandGroup); _i < _Object$values.length; _i++) {
            var group = _Object$values[_i];

            var sorted = _.sortBy(group, 'v').reverse();

            var py1i = null;
            var py2i = null;

            for (var i = 0; i < sorted.length - 1; i++) {
              var py1 = y(sorted[i].v) + POINT_RADIUS + 1;
              var py2 = y(sorted[i + 1].v) - POINT_RADIUS - 1;

              if (_.isNumber(py1i) && _.isNumber(py2i) && py1 < py2) {
                addCollision(sorted[py1i].t, sorted[py1i], sorted[py2i]);
                py1i = null;
                py2i = null;
                continue;
              }

              if (py1 > py2) {
                py1i = _.isNumber(py1i) ? py1i : i;
                py2i = i + 1;
              }

              if (_.isNumber(py1i) && _.isNumber(py2i) && i === sorted.length - 2) {
                addCollision(sorted[py1i].t, sorted[py1i], sorted[py2i]);
              }
            }
          }

          var bars = g.selectAll("g").data(collisions).join("g").attr("stroke-linecap", "round").attr("transform", function (d) {
            return "translate(".concat(x(d.t), ",0)");
          });
          bars.append("line").attr("y1", function (d) {
            return y(d.py1.v);
          }).attr("y2", function (d) {
            return y(d.py2.v);
          }).attr("stroke-width", POINT_RADIUS * 2).attr("stroke", DATA_GRAY);
        }

        function tapBands(g) {
          var dates = _.map(_.values(tickBandGroup), function (o) {
            return o[0].t;
          });

          return g.selectAll("g").data(_.uniq(dates)).join("line").attr("y1", margin.top - 4).attr("y2", height - margin.bottom).attr("stroke-width", POINT_RADIUS * 2 + 4).attr("stroke", "transparent").attr("transform", function (d) {
            return "translate(".concat(x(d), ",0)");
          }).on('click', handleSelection);
        }

        function handleSelection(date, i) {
          clearTooltips();
          d3.select("#".concat(id, " .unit")).classed('transparent', true);
          var values = tickBandGroup[date];
          var minMax = d3.extent(_.map(values, 'v'));

          var textValue = _.uniq(_.map(minMax, function (v) {
            return valueFormatter()(v);
          })).join(' – ');

          d3.select(this).call(function (g) {
            return selectionBackground.append("line").attr("class", "tooltip").attr("y1", margin.top - 4).attr('y2', height - margin.bottom).attr('stroke', GS_MED_LIGHT).attr('stroke-width', 1).attr('transform', "translate(".concat(x(date), ", 0)"));
          }).call(function (g) {
            return selectionBackground.append('text').attr("y", 0).attr("x", x(date)).attr("dy", "1em").attr('class', 'tooltip').attr("style", "font-size: ".concat(CAPTION_1_FONT_SIZE, "px; font-weight: bold; text-anchor: middle")).text(textValue);
          }).call(function (g) {
            var text = timeFormat()(date);
            selectionBackground.append('text').attr("y", 14).attr("x", x(date)).attr("dy", "1em").attr('class', 'tooltip').attr("style", "font-size: ".concat(SUB_CAPTION_FONT_SIZE, "px; fill: ").concat(GS_DARK, "; text-anchor: middle")).text(text);
          }).call(function (g) {
            var values = tickBandGroup[date];

            var _iterator = _createForOfIteratorHelper(values),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var value = _step.value;
                selectionBackground.append('circle').attr('class', 'tooltip').attr('cx', x(date)).attr('cy', y(value.v)).attr('r', POINT_RADIUS + 1) // FIXME??
                .attr('fill', '#FFFFFF');
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          });
        }

        function pageBack() {
          if (pageIndexToRender > 0) {
            renderGraphData(svg, pages, pageIndexToRender - 1);
          }
        }

        function pageForward() {
          if (pageIndexToRender < pages.length - 1) {
            renderGraphData(svg, pages, pageIndexToRender + 1);
          }
        }

        if (data.length === 0) {
          throw new Error('Cannot display, dataset does not contain any plottable values');
        }

        var plotWidth = width - margin.right - 48 - margin.left;
        var isWide = plotWidth > 500;
        var tickBandGroup = getXTickGroups();
        d3.select("#".concat(id, " svg")).select("#selection-background").selectAll("*").remove();
        d3.select("#".concat(id, " svg")).select("#tap-background").selectAll("*").remove();
        d3.select("#".concat(id, " svg")).select("#unit-label").selectAll("*").remove();
        d3.select("#".concat(id, " svg")).select("#points").selectAll("*").remove();
        d3.select("#".concat(id, " svg")).select("#bars").selectAll("*").remove();
        d3.select("#".concat(id, " svg")).select("#tap-bands").selectAll("*").remove();
        svg.attr("viewBox", [0, 0, width, height]);
        var selectionBackground = svg.select("#selection-background");
        svg.select("#tap-background").call(tapBackground);
        svg.select("#unit-label").call(unitLabel);
        svg.select("#points").call(points);
        svg.select("#bars").call(bars);
        svg.select("#tap-bands").call(tapBands);
        svg.select("#x-axis").call(xAxis);
        svg.select("#y-axis").call(yAxis);
        var startDragX;

        function paginate(delta) {
          if (delta < -1 * DRAG_PIXELS_TO_PAGINATE) {
            startDragX = null;
            pageForward();
          } else if (delta > DRAG_PIXELS_TO_PAGINATE) {
            startDragX = null;
            pageBack();
          }
        }

        svg.call(d3.drag().on("start", function () {
          startDragX = d3.event.x;
        }).on("drag", function () {
          startDragX = startDragX || d3.event.x;
          var delta = d3.event.x - startDragX;
          paginate(delta);
        }).on("end", function (f, i, n) {
          startDragX = startDragX || d3.event.x;
          var delta = d3.event.x - startDragX;
          paginate(delta);
          startDragX = null;
        }));
      }

      var svg = d3.create("svg");
      svg.append("rect").attr("id", "tap-background");
      svg.append("text").attr("id", "unit-label");
      svg.append("g").attr("id", "selection-background");
      svg.append("g").attr("id", "points");
      svg.append("g").attr("id", "bars");
      svg.append("g").attr("id", "tap-bands");
      svg.append("g").attr("id", "x-axis").append("g").attr("id", "x-axis-content");
      svg.append("g").attr("id", "y-axis").append("g").attr("id", "y-axis-content");
      var records = prepareData(this.records);
      var pages = gatherDataset(records);
      var currentPage = pages.length - 1;
      renderGraphData(svg, pages, currentPage);
      return svg.node();
    }
  }]);

  return TrackableObservationGraph;
}();

export default TrackableObservationGraph;